export default __webpack_public_path__ + "66fa3803b3777b645b24305611893b77.png";